(function(window, document, $, undefined){

    'use strict';
    window.main = {};

    main.init = function() {
        main.accessibility();
        main.accessibility_accordion();
        main.accessibility_fancybox();
        main.accessibility_post_buttons();
    }

    main.accessibility_fancybox =  function() {

        setTimeout(() => {
            $('#fancybox-left').append('Fancybox Left');
            $('#fancybox-right').append('Fancybox Right');
        }, '100');

    }

    main.accessibility_post_buttons = function() {

        $( '.et_pb_post' ).each(function( index ) {

            var $title = $(this).find('.entry-title a').text();
            $(this).find('.more-link').append('<div class="visually-hidden">about ' + $title.toLowerCase() + '</div>');
        });
    }

    main.accessibility_accordion =  function() {

        $( '.et_pb_toggle' ).each(function( index ) {

            index = index + 1;

            console.log( index + ": " + $( this ).text() );
            $(this).find('h5.et_pb_toggle_title').attr('role', 'button').attr('aria-expanded', 'false').attr('aria-controls', 'toggle-'  + index).attr('id', 'headerToggle-' + index);
            $(this).find('.et_pb_toggle_content').attr('role', 'region').attr('aria-labelledby', 'headerToggle-' + index).attr('id', 'toggle-' + index);
        });

        $('.et_pb_toggle_title').on('click', function() {

            if ( $( this ).parent().hasClass( 'et_pb_toggle_close' ) ) {
                $(this).attr('aria-expanded', 'true');
            } else {
                $(this).attr('aria-expanded', 'false');
            }
        });

    }

    main.accessibility =  function() {
        $('.et_pb_scroll_top').attr('role', 'button')
            .append('<span class="visually-hidden">Scroll to top</span>')
            .attr('tabindex', '0');
        $('.scroll-down-container').attr('role', 'button');
        $('#top-menu').attr('role', 'menubar');
        $('#top-menu a').attr('role', 'menuitem');
        $('#mobile_menu a').attr('role', 'menuitem');
        $('ul.sub-menu').attr('role', 'menu');
        $('.menu-item-18940 .sub-menu').attr('aria-label', 'Struggling to pay your bill?');
        $('.menu-item-18940 > a').attr('aria-haspopup', true);
        $('.menu-item-18940 > a').attr('aria-expanded', false);
        $('.menu-item-19082 .sub-menu').attr('aria-label', 'Struggling to pay your bill?');
        $('.menu-item-19082 > a').attr('aria-haspopup', true);
        $('.menu-item-19082 > a').attr('aria-expanded', false);
        $('.menu-item-11972 .sub-menu').attr('aria-label', 'Definitions');
        $('.menu-item-11972 > a').attr('aria-haspopup', true);
        $('.menu-item-11972 > a').attr('aria-expanded', false);
        $('.menu-item-83 .sub-menu').attr('aria-label', 'Related Links').attr('role', 'menu');
        $('.menu-item-83 > a').attr('aria-haspopup', true);
        $('.menu-item-83 > a').attr('aria-expanded', false);
        $('.logo_helper').attr('role', 'none');

        $('.scroll-down-container').attr('role', 'button');

        $('a[target="_blank"]').each(function() {
            $(this).attr('aria-label', 'Opens in a new window');
        });

        $('#main-content').attr('role', 'main');
    }

    $(document).on( 'ready', main.init );


})(window, document, jQuery);

